import { useEffect, useState } from 'react';

import { TOP_BAR_SCROLL_THRESHOLD, isScrolledPast } from './shell.logic';

/**
 * True once the page (window) scrolled more than `threshold` px. Only re-renders
 * when the answer flips, not on every scroll event.
 */
export function useScrolled(threshold: number = TOP_BAR_SCROLL_THRESHOLD): boolean {
  const [scrolled, setScrolled] = useState(() => typeof window !== 'undefined' && isScrolledPast(window.scrollY, threshold));
  useEffect(() => {
    const update = () => setScrolled(isScrolledPast(window.scrollY, threshold));
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [threshold]);
  return scrolled;
}
